<template>
  <b-navbar-brand>
    <!-- Logo icon -->
    <strong class="logo-icon">
      <!--Logo blanco ACIQUI-->
      <img class="logo logo-navbar" :src="aciquiLogo" alt="homepage" />
      
    </strong>
  </b-navbar-brand>
</template>

<script>
import aciquiLogo from "@/assets/images/aciqui.svg";

export default {
  name: "LogoLight",
  data: () => ({
    aciquiLogo: aciquiLogo,
  })
};
</script>

<style>

 img{
  max-width: 100px;
 }

.logo{
  width: 100%;
  margin-bottom: 0.2rem;
  margin-top: 0.5rem;
  margin-left: 0px;
  margin-right: 0px;
}
@media (max-width: 991.98px)  and (max-height: 950px){
  .logo{
    width: 100%;
    margin-bottom: 0px;
    margin-top: 2rem;
    margin-left: 15px;
    margin-right: 0px;
  }
}


</style>